import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';
import {convertGQLToRESTAnalyticsQuery} from 'insights/analytics-queries/data/AnalyticsQueryGQLRESTConverters';
import {AnalyticsQuerySpecRequest} from 'insights/analytics-queries/RESTAnalyticsQueryTypes';
import EditableTextField from 'ui-library/inputs/EditableTextField';
import {withLoadingScreen} from 'util/Promises';

type AnalyticsQuery = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>['analyticsQueries'][number];

export interface EditableBlockNameProps {
  actions: {
    updateAnalyticsQuery: (analyticsQueryId: string, data: AnalyticsQuerySpecRequest) => Promise<void>;
  };
  analyticsQuery: AnalyticsQuery;
}

export default function EditableBlockName(props: EditableBlockNameProps): JSX.Element {
  function handleChangeName(newName: string): void {
    const querySpecRequest = {
      ...convertGQLToRESTAnalyticsQuery(props.analyticsQuery),
      name: newName,
    };

    withLoadingScreen(
      props.actions.updateAnalyticsQuery(props.analyticsQuery.id, querySpecRequest),
      'Saving block...'
    );
  }

  return (
    <EditableTextField
      inputClassName={css(styles.input)}
      requestChange={handleChangeName}
      value={props.analyticsQuery.name}
      isDisabled={false}
    />
  );
}

const styles = StyleSheet.create({input: {width: 300}});
